import React from 'react';
import 'animate.css';


const About = () => {
  return (
   <section id='about' >
     <div className="flex flex-col lg:flex-row items-center justify-between min-h-screen bg-gray-900 text-white p-8">
      <div className="lg:w-1/2 text-center lg:text-left mb-8 lg:mb-0 animate__animated animate__fadeInLeft lg:ml-20">
        <div>
          <p className=" mt-32 md:mt-0 font-bold text-3xl mb-2 animate__animated animate__fadeInLeft animate__delay-1.5s">
            Hi....
          </p>
          <p className="font-bold text-2xl mb-2 animate__animated animate__fadeInLeft animate__delay-1s md:text-4xl">
            I'm Nikhil Bhalkar
          </p>
          <p className="font-bold text-1xl mb-4 animate__animated animate__fadeInLeft animate__delay-2s md:text-4xl">
            App Developer |  Full Stack Developer
          </p>
        </div>
       <a href="https://drive.google.com/file/d/1o1K5rAQqbnkBde5rOm0KwxFmwwhqqihO/view?usp=sharing">
       <button className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 animate__animated animate__fadeInUp animate__delay-2s">
          Download Resume
        </button>
       </a>
        
      </div>
      <div className="lg:w-1/2 flex justify-center animate__animated animate__fadeInRight">
        <img className="h-[300px] lg:h-[600px] hover:scale-110 transition-transform duration-300" src="/nikhilAvatar.png" alt="Nikhil Avatar" />
      </div>
    </div>
   </section>
  );
};

export default About;
